import { module } from 'angular';

import { default as periodSelectorName, PeriodSelector } from './period-selector.component.ajs';

export default module('contact.commons.toolbox.period-selector', []).component(periodSelectorName, new PeriodSelector()).name;
